
import React, { useEffect, useState } from 'react';

import ExternalConfiguration from '../../external-configuration';

// import './Wrapper-custom-4-player.css';

const Constants = {
  PlayerId: 'custom-4-player',
  PlayerScritpSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.custom_4_player}/zebra.js`,
};

const Globals = {
  playerScript: null,
  player: null,
};

const onLoad = (event, props) => {
  console.log( 'onLoad');
  console.log( 'event: ', event);
  console.log( 'props: ', props);
  console.log( 'window.bradmax: ', window.bradmax);
  const player_element = document.getElementById( Constants.PlayerId);
  window.bradmax.player.create( player_element, {
    dataProvider: {
      skin: { theme: 'zebra' },
      source: [
        { url: ExternalConfiguration.DefaultErrorVideo },
      ],
    },
  });
}

export default function Wrapper_custom_4_player( props) {
  const { width, height } = props.custom_4_playerConfiguration?.customProps ?? {};
  const { PlayerId, PlayerScritp } = Constants;
  const { player } = Globals;

  if( player && (player.getWidth() !== width || player.getHeight() !== height)) player.resize( width, height);

  useEffect( () => {
    Globals.playerScript = document.createElement( 'script');
    Globals.playerScript.src = Constants.PlayerScritpSrc;
    Globals.playerScript.async = true;
    Globals.playerScript.onload = event => onLoad( event, props);
    document.head.append( Globals.playerScript );
  }, []);

  // console.log( 'components::Wrapper-custom-4-player::render - props: ', props);    // DEVELOP
  return (
    <div className='wrapper-custom-4-player-container'>
      <div id={Constants.PlayerId} />
    </div>
  );
}
